import domready from 'domready';
import { createEmbedEmotionCache } from '@embed/createEmbedEmotionCache';
import { floatingButtonRender } from '@embed/floatingButtonRender';
import { uuidv4 } from '@embed/helpers';
import storyblockRender from '@embed/storyblockRender';
import fwnInit from '@src/embeds/utils/fwnInit';
// Import webcomponents so they
// are bundled with fwn.js
import './channel-button';
import './embed-feed';
import './storyblock';
import './storylink';
;
((w, d) => {
    var _a, _b, _c;
    // Safely create global fwn object
    // if does not exists (For cases when fwn.js loaded manually)
    fwnInit(w);
    // Resolve dict of initial attributs e.g. fwn('init', 'partner_id')
    const initials = (_c = (_b = (_a = w._fwn) === null || _a === void 0 ? void 0 : _a.queue) === null || _b === void 0 ? void 0 : _b.reduce((acc, curr) => {
        if (curr[0] === Object(curr[0])) {
            acc[uuidv4()] = curr[0];
            return acc;
        }
        else {
            const instance = '_default';
            const key = curr[0];
            const value = curr[1];
            acc[instance] = acc[instance] || {};
            acc[instance][key] = value;
            return acc;
        }
    }, {})) !== null && _c !== void 0 ? _c : {};
    if (w._fwn) {
        w._fwn.queue = [];
    }
    // Create cache for emotion
    const emotionCache = createEmbedEmotionCache({
        container: d.head,
        speedy: true,
    });
    // Render embed feed
    Object.keys(initials).forEach((instance) => {
        var _a, _b;
        const widgetParams = initials[instance];
        (_b = (_a = w._fwn) === null || _a === void 0 ? void 0 : _a.render) === null || _b === void 0 ? void 0 : _b.call(_a, widgetParams);
    });
    function renderButton(button) {
        var _a;
        const htmlHref = button.getAttribute('href') || '';
        button.removeAttribute('href');
        const match = htmlHref.match(/\/\/(fw.tv|firework.tv|fireworktv.com)\/(ch\/)?(?<channel>[a-zA-Z0-9_-]+)/);
        floatingButtonRender(Object.assign(Object.assign({}, button.dataset), { channel: button.dataset.channel || ((_a = match === null || match === void 0 ? void 0 : match.groups) === null || _a === void 0 ? void 0 : _a.channel), target: button }), emotionCache);
    }
    function renderBlockquoteWidget(widgetElement) {
        const { widget } = widgetElement.dataset;
        switch (widget) {
            case 'hero': {
                widgetElement.innerHTML = '';
                const { channel, video, hashtag } = widgetElement.dataset;
                storyblockRender({
                    channel,
                    video,
                    hashtag,
                    max_videos: video && !channel ? 1 : undefined,
                    height: '75vh',
                    target: widgetElement,
                }, emotionCache);
                break;
            }
            default: {
                widgetElement.remove();
                // eslint-disable-next-line no-console
                console.error(`Oops! It looks like the widget "${widget}" isn't supported in this version of Firework Widget Network.`);
            }
        }
    }
    domready(() => {
        // render Floating Channel Button
        const button = d.querySelector('a.fw-channel');
        if (button) {
            renderButton(button);
        }
        setInterval(() => {
            const widgetElements = d.getElementsByClassName('fw-embed');
            Array.from(widgetElements).forEach((element) => {
                if (!element.getAttribute('initialized')) {
                    renderBlockquoteWidget(element);
                }
                element.setAttribute('initialized', 'true');
            });
        }, 500);
    });
})(window, document);
